// extracted by mini-css-extract-plugin
export var addButton = "_ji-0";
export var border = "_ji-8";
export var check = "_ji-h";
export var danger = "_ji-6";
export var dropdownContainer = "_ji-1";
export var editModalBody = "_ji-j";
export var footerContainer = "_ji-i";
export var fullWidth = "_ji-a";
export var hide = "_ji-9";
export var icon = "_ji-3";
export var input = "_ji-7";
export var inputFlex = "_ji-b";
export var inputWrapper = "_ji-c";
export var manualFocus = "_ji-5";
export var optionButton = "_ji-4";
export var pillWrapper = "_ji-e";
export var pointer = "_ji-2";
export var showOverflow = "_ji-f";
export var tagsFlex = "_ji-d";
export var xButton = "_ji-g";